export default __webpack_public_path__ + "static/media/marketplact_empty.68475ca1.png";